import axios from "axios";
import {materialCloudServicesPath} from "../../../Constants";

const jobRestUrl = materialCloudServicesPath + '/user/job-metric-edge-material'

export default class JobMetricEdge {

    static async getJobMetricEdgeByMaterialId(materialId) {
        return axios.get(jobRestUrl + '/by-material-id-for-catalog'
            + '?materialId=' + materialId);
    }
}